export const extractRuleValue = (rules, fieldName) => {
  if (!rules || !Array.isArray(rules)) {
    return null;
  }

  const rule = rules.find(r => r.field === fieldName);
  if (rule && rule.value && rule.value[0] != null) {
    return rule.value[0];
  }

  return null;
};

export const getInvoiceType = rules => extractRuleValue(rules, 'invoice_type');

export const getSubscriptionPeriod = rules =>
  extractRuleValue(rules, 'subscription_period');
